import React from "react";

const Loader = () => {
  return (
    <div className="loaderdesign">
      <div>
        <div class="star">
          <div class="corner corner--top-left"></div>
          <div class="corner corner--top-right"></div>
          <div class="corner corner--bottom-right"></div>
          <div class="corner corner--bottom-left"></div>
        </div>
        <div class="loading">
          <div class="loading__letter">L</div>
          <div class="loading__letter">o</div>
          <div class="loading__letter">a</div>
          <div class="loading__letter">d</div>
          <div class="loading__letter">i</div>
          <div class="loading__letter">n</div>
          <div class="loading__letter">g</div>
          <div class="loading__letter">.</div>
          <div class="loading__letter">.</div>
          <div class="loading__letter">.</div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
